import { render } from "./AddFormuleModal.vue?vue&type=template&id=6ed2566e&ts=true"
import script from "./AddFormuleModal.vue?vue&type=script&lang=ts"
export * from "./AddFormuleModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__